// extracted by mini-css-extract-plugin
export default {"numberOfOptions":"NumberOfOptions_numberOfOptions__-uulC"};